import { Radio } from 'antd';
import { Text } from 'components/mvp-typography';
import { RatingPropsNew } from '../types';

export interface MinMaxRadioButtons
  extends Pick<RatingPropsNew, 'disabled' | 'max' | 'min' | 'colorsForward'> {}

/**
 * Render a list of radio buttons to select a number between `min` and `max`
 */
export function MinMaxRadioButtons(props: Required<MinMaxRadioButtons>) {
  const { max, min, colorsForward, disabled } = props;
  // maybe pull out the color "classes" into it's own class or helper file
  let buttonClasses = [
    'crx-warning',
    'crx-orange',
    'crx-orange-light',
    'crx-yellow',
    'crx-green'
  ];
  const buttonLength = max - min + 1;

  const buttons = [];
  let j = 0;

  if (buttonLength === 7) {
    buttonClasses = [
      'crx-warning',
      'crx-orange',
      'crx-orange',
      'crx-orange-light',
      'crx-orange-light',
      'crx-yellow',
      'crx-green'
    ];
  } else if (buttonLength === 5) {
    // do nothing our default buttonClasses is fine
  } else if (buttonLength === 4)
    buttonClasses = ['crx-warning', 'crx-yellow', 'crx-blue', 'crx-green'];
  else if (buttonLength === 3) {
    buttonClasses = ['crx-warning', 'crx-orange-light', 'crx-green'];
  } else if (buttonLength === 2) {
    buttonClasses = ['crx-warning', 'crx-green'];
  } else {
    console.warn('Unexpected color case here at length: ', max - min);
  }

  /**
   * Reverse the colors if needed
   */
  if (colorsForward === false) buttonClasses = buttonClasses.reverse();

  /**
   * Generate the list of radio buttons to render
   */
  for (let i = min; i <= max; i++) {
    const buttonClass = buttonClasses[j++];

    // Convert the number to a string. If we don't do this then the falsy value of `0` is not rendered
    const formattedIndex = i.toString();

    buttons.push(
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        }}
      >
        {/* Invisible element to push the radio button to the center */}
        <Text style={{ fontFamily: 'Comfortaa', opacity: 0 }}>
          {formattedIndex}
        </Text>
        <Radio
          key={i}
          disabled={disabled}
          value={i}
          className={'custom-radio ' + `${buttonClass}`}
        />
        <Text style={{ fontFamily: 'Comfortaa' }}>{formattedIndex}</Text>
      </div>
    );
  }

  return <>{buttons}</>;
}
